import React from 'react';
import MainRoute from './routing/MainRoute';
import { AuthProvider, useAuth } from './contexts';
import { PHONE_ROLES, type Role } from '@rsmaids/shared/constants/roles';
import { KeyboardProvider } from './contexts/KeyboardContext';
import { IonApp } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import IvrPanel from './desktop/components/IvrPanel/IvrPanel';
import SoftPhoneModal from './components/SoftPhoneModal/SoftPhoneModal';
import IncomingCallOverlay from './components/IncomingCallOverlay';

// The phone (the softphone on mobile, the IVR panel on desktop) is for a lead and above: staff and clients get none of it
const PhoneHost: React.FC = () => {
    const { authState } = useAuth();
    if (!PHONE_ROLES.includes(authState.user?.role as Role)) return null;
    return import.meta.env.VITE_PLATFORM === 'desktop'
        ? <IvrPanel />
        : <><SoftPhoneModal /><IncomingCallOverlay /></>;
};

const App: React.FC = () => {
    return (
        <KeyboardProvider>
        <AuthProvider>
            <IonApp>
                <IonReactRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
                    <MainRoute />
                </IonReactRouter>
                <PhoneHost />
            </IonApp>
        </AuthProvider>
        </KeyboardProvider>
    );
};

export default App;
